import { BrandRing, BrandDots } from "./brandRing";

interface PageLoaderProps {
  message?: string;
  subtitle?: string;
  fullScreen?: boolean;
}

export const PageLoader: React.FC<PageLoaderProps> = ({
  message = "Loading...",
  subtitle = "Please wait while we fetch the data",
  fullScreen = false,
}) => {
  const containerClass = fullScreen
    ? "fixed inset-0 z-50 bg-[#0b0a07] flex items-center justify-center"
    : "flex flex-col items-center justify-center min-h-[440px] mt-2";

  return (
    <div className={containerClass}>
      <div className="admin-rise flex flex-col items-center justify-center">
        <BrandRing size={96} />

        <div className="text-center space-y-2 mt-8">
          <p className="text-[#E8D5A3] font-semibold text-xl tracking-wide">
            {message}
          </p>
          {subtitle && (
            <p className="text-[#8b8270] text-sm max-w-md">{subtitle}</p>
          )}
        </div>

        <div className="mt-6 h-1 w-40 overflow-hidden rounded-full bg-[#241d10]">
          <div
            className="h-full w-1/3 rounded-full bg-gradient-to-r from-transparent via-[#BBA473] to-transparent"
            style={{ animation: "admin-shimmer 1.3s ease-in-out infinite" }}
          />
        </div>

        <div className="mt-5">
          <BrandDots />
        </div>
      </div>
    </div>
  );
};
